function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
import ParagraphConfig from "segments/desktop/core-components/paragraph/fields-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Marquee",
    fields: _object_spread_props(_object_spread({}, ThemeConfig), {
        textBoxText: {
            type: FIELD_TYPES.TEXT,
            label: "Text Box Text"
        },
        titleConfig: {
            type: FIELD_TYPES.NESTED,
            label: "Title Config",
            fields: _object_spread({}, TitleConfig)
        },
        subTitleConfig: {
            type: FIELD_TYPES.NESTED,
            label: "subTitle config",
            fields: _object_spread({}, ParagraphConfig)
        },
        tagsLines: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tags Lines",
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: {
                    items: {
                        type: FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Tags",
                        maxLimit: 15,
                        nestedConfig: {
                            type: FIELD_TYPES.NESTED,
                            fields: {
                                text: {
                                    type: FIELD_TYPES.TEXT,
                                    label: "Text",
                                    translatable: true
                                },
                                image: {
                                    type: FIELD_TYPES.GALLERY,
                                    label: "Image"
                                },
                                backgroundColor: {
                                    type: FIELD_TYPES.COLOR_PICKER,
                                    label: "Background Color"
                                },
                                hoverTextAndBorderColor: {
                                    type: FIELD_TYPES.COLOR_PICKER,
                                    label: "Hover Text Color"
                                },
                                selectedTextAndBorderColor: {
                                    type: FIELD_TYPES.COLOR_PICKER,
                                    label: "Select Text Color"
                                }
                            }
                        }
                    }
                }
            }
        }
    })
};
